import { usePermissions } from 'hooks/usePermissions'
import { HubspotSyncConfig } from 'pages/Admin/AdminTools/Configuration/HubspotSync'

/**
 * The loan sync mapping, under the vendor's own credentials because this is where an admin goes
 * looking for it. The same component and the same stored config as
 * Admin > Configuration > HubSpot Sync, so neither place can drift from the other.
 *
 * Saving posts to `/admin/config/hubspotMapping`, which requires AdminTools, while this page only
 * requires Vendors. Without the check a Vendors-only user would fill the whole form in and have
 * the save refused, so they are pointed at the screen their permissions do reach instead.
 */
export const HubspotSyncSection = () => {
  const { hasPermission } = usePermissions()

  return (
    <div className="mt-8 pt-6 border-t">
      <p className="text-lg font-bold mb-1">Loan Sync</p>
      <p className="text-sm text-gray-600 mb-4">
        What this tenant writes into HubSpot when a loan is created and when its status changes.
      </p>
      {hasPermission('AdminTools') ? (
        <HubspotSyncConfig showVendorPointer={false} />
      ) : (
        <p className="text-sm text-gray-600">
          The mapping is edited under Admin &gt; Configuration &gt; HubSpot Sync, which needs the Admin Tools
          permission.
        </p>
      )}
    </div>
  )
}
